import InfiniteScroll from "../../../codercompanion/components/infinite-scroll";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Spinner } from "../../common/Helper";

export default function DropdownFilter({
  column,
  options,
  selectedOptions,
  onChangeHandlerCheckBox,
  closeDropdown,
  stylePosition,
  isLoading,
  loadingMoreUsers,
  loadMoreOptions,
  handleSearchChange,
  hasMoreAssgineByUsers,
  hasMoreAssgineToUsers,
  hasMoreUploadedBy,
  hasMoreLastAuditedDate,
  applyFilters,
  searchErrorMessage,
  hasMoreCodedBy,
  hasMoreDescriptions,
  hasMoreReferenceIds,
  descriptionSearchData,
  setDescriptionSearchData
}) {
  const dropdownRef = useRef(null);
  const style = {
    left: stylePosition.positionX ?? 0,
    top: (stylePosition.positionY ?? 0) + 8,
  };

  const getFormattedDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString();
    // + " " + date.toLocaleTimeString();
  };

  const hasMoreadata = () => {
    if (column === "assigned_by") {
      return hasMoreAssgineByUsers;
    } else if (column === "assigned_to") {
      return hasMoreAssgineToUsers;
    } else if (column === "uploaded_by_user_name") {
      return hasMoreUploadedBy;
    } else if (column === "hcp_line_updated_at") {
      return hasMoreLastAuditedDate;
    } else if (column === "coder_name") {
      return hasMoreCodedBy;
    }
    else if (column === "short_description") {
      return hasMoreDescriptions;
    }
    else if(column === "audit_ref_no"){
      return hasMoreReferenceIds;
    }
    else {
      return true;
    }
  };

  const handleApply = () => {
    applyFilters();
    closeDropdown();
  };

  const handleClear = () => {
    selectedOptions.forEach((option) => {
      onChangeHandlerCheckBox(column, option, false);
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeDropdown]);

  const label =
  column === "hcp_line_updated_at"
    ? ""
    : column === "short_description"
      ? "Search Description"
      : column === "audit_ref_no"
        ? "Search Reference Id"
        : `search ${column}`;

  return (
    <article className="dropdown-overlay">
      <div className="dropdown-container" style={style} ref={dropdownRef}>
        <div className="dropdown-content-list-filters">
          {isLoading ? (
            <Spinner />
          ) : (
            <>
              {/* {(column === "assigned_by" || column === "assigned_to" || column === "hcp_line_updated_at" || column === "uploaded_by_user_name") && ( */}
              <input
                type={column === "hcp_line_updated_at" ? "date" : "text"}
                placeholder={
    column === "hcp_line_updated_at"
      ? ""
      : column === "short_description"
        ? "Search Description"
        : column === "audit_ref_no"
          ? "Search Reference Id"
          : `search ${column}`
  }
                // placeholder={column !=="hcp_line_updated_at"?`Search ${column}`:""}
                // `Search ${column}` 
                onChange={(e) => handleSearchChange(column, e.target.value)}
                style={{
                  marginBottom: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  padding: "5px",
                  fontSize: "12px",
                }}
              />
              {/* // )} */}
              <InfiniteScroll
                className="dropdown-options"
                hasData={hasMoreadata()}
                loadMore={() => {
                  if (!loadingMoreUsers) {
                    loadMoreOptions();
                  }
                }}
                isLoading={loadingMoreUsers}
              >
                {searchErrorMessage ? (
                  <p style={{ color: "red", fontSize: "14px" }}>
                    {searchErrorMessage}
                  </p>
                ) : (
                  // options.length === 0 && !isLoading ?(
                  //   <div className="no-more-data">No more data</div>
                  options.map((option) => (
                    <label
                      className="chekbox-label"
                      key={
                        column === "coder_name" ||
                        column === "status" ||
                        column === "audit_ref_no" ||
                        column === "uploaded_by_user_name" ||
                        column === "short_description" ||
                        column === "hcp_line_updated_at"
                        
                          ? option
                          : option.user_id
                      }
                    >
                      <div style={{ display: "flex"}}>
                        <input
                          type="checkbox"
                          className="checkbox-input"
                          value={
                            column === "coder_name" ||
                            column === "status" ||
                            column === "short_description" ||
                            column === "audit_ref_no" ||
                            column === "uploaded_by_user_name" ||
                            column === "hcp_line_updated_at"
                              ? option
                              : option.user_id
                          }
                          checked={selectedOptions.some((selected) =>
                            column === "coder_name" ||
                            column === "status" ||
                            column === "short_description" ||
                            column === "audit_ref_no" ||
                            column === "uploaded_by_user_name" ||
                            column === "hcp_line_updated_at"
                              ? selected === option
                              : selected === option.user_id
                          )}
                          onChange={(e) =>
                            onChangeHandlerCheckBox(
                              column,
                              column === "coder_name" ||
                                column === "status" ||
                                column === "short_description" ||
                                column === "audit_ref_no" ||
                                column === "uploaded_by_user_name" ||
                                column === "hcp_line_updated_at"
                                ? option
                                : option.user_id,
                              e.target.checked
                            )
                          }
                        />
                        <p className="options-data-text">
                          {column === "coder_name" ||
                          column === "status" ||
                          column === "short_description" ||
                          column === "audit_ref_no" ||
                          column === "uploaded_by_user_name"
                            ? option
                            : column === "hcp_line_updated_at"
                            ? getFormattedDate(option)
                            : option.username}
                        </p>
                      </div>
                    </label>
                  ))
                )}
              </InfiniteScroll>
            </>
          )}

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <button onClick={handleClear} className="clear-button">
              Clear
            </button>
            <button onClick={handleApply} className="apply-button">
              Apply
            </button>
          </div>
        </div>
      </div>
    </article>
  );
};